import { Epm } from 'grids/epm/epm';

export const EpmWrapper = (props) => {
  return <Epm {...props} theme="dark" />;
};
